import { createRouter, createWebHistory } from "vue-router";

// Auth
import Login from "../pages/login.vue";
import Forgot from "../pages/Forgot.vue";
import Reset  from "../pages/Reset.vue";
// Collaborate
import ETOProjects from "../pages/ETOProjects.vue";
import ETOProjectDetails from "../pages/ETOProjectDetails.vue";



import Trailblazor from "../pages/Trailblazor.vue";
import TrailblazorSingle from "../pages/TrailblazorSingle.vue";
import Announcements from "../pages/Announcements.vue";
import AnnouncementSingle from "../pages/AnnouncementSingle.vue";
import FromFort from "../pages/FromFort.vue";
import FromFortNew from "../pages/FromFortNew.vue";

import Home from "../pages/Home.vue";
import HomeVids from "../pages/HomeVids.vue";
import HomeProjects from "../pages/HomeProjects.vue";
import HomeProjectsPodcast from "../pages/HomeProjectsPodcast.vue";
import HomeLeaderboard from "@/pages/HomeLeaderboard.vue";
import HomeLeaderboardOptionB from "@/pages/HomeLeaderboardOptionB.vue";
import HomeLeaderboardOptionMulti from "@/pages/HomeLeaderboardOptionMulti.vue";

import HomeLeaderboardOptionC from "@/pages/HomeLeaderboardOptionC.vue";
import PodcastCollection from "@/pages/PodcastsCollection.vue";
import ACList from "../pages/ACLookup.vue";
import FAQ from "../pages/faq.vue";
import Calendar from "../pages/Calendar.vue";
import Questions from "../pages/QuestionsNew.vue";
import QuestionsSingle from "../pages/QuestionsSingleNew.vue";
import Media from "../pages/Media2.vue";

import Listings from "../pages/Listings.vue";
import Acknowledgments from "@/pages/Acknowledgments.vue";
import Invoices from "@/pages/Invoices.vue";
import OrderDetails from "../pages/OrderDetails.vue";
import ExpeditedOrders from "../pages/ExpeditedOrders.vue";
import ExpeditedOrderDetails from "../pages/ExpeditedOrderDetailsNew.vue";
import ExpeditedOrderAdd from "../pages/ExpeditedOrderAdd.vue";

import Interterritorial from "../pages/Interterritorial.vue";
import InterterritorialAdd from "../pages/InterterritorialAdd.vue";
import InterterritorialDetails from "../pages/InterterritorialDetails.vue";


import CashManagement from "../pages/CashManagement.vue";
import CashManagementSingle from "../pages/CashManagementSingle.vue";
import LeadTimes from "../pages/LeadTimes.vue";
import LeadTimesEdit from "../pages/LeadTimesEdit.vue";
import LeadTimeHistory from "../pages/LeadTimeHistoryNew.vue";
import Warranty from "../pages/warranty.vue";
import GSAs from "../pages/GSAs.vue";
import ADS from "../pages/ADS.vue";


import RFRs from "../pages/RFRs.vue";
import RFRDetails from "../pages/RFRDetails.vue";
import RFRadd from "../pages/RFRadd.vue";

import RGAs from "../pages/RGAs.vue";
import RGADetails from "../pages/RGADetails.vue";
import RGAadd from "../pages/RGAadd.vue";

import ReportsNew from "../pages/reportsNew.vue";
import ReportDetails from "@/pages/reportDetailsNew.vue";
import SalesReps from "@/pages/salesReps.vue";

import Parts from "@/pages/PriceLists.vue"; 
import MajorProjects from "@/pages/MajorProjectsRegistration.vue"; 
import ReleaseNotes from "@/pages/ReleaseNotes.vue";
import PrivacyPolicy from "@/pages/privacy-policy.vue";
import OpportunityRegistration from "@/pages/OpportunityRegistration.vue";

import { jwtDecode } from 'jwt-decode';
import { logoutOnTokenExpired } from '@/utils/auth'; 

// 
// import RGAs from "../pages/RGAs.vue";
// import RGAadd from "../pages/RGAadd.vue";




import FieldService from "../pages/FieldService.vue";
import SalesTraining from "../pages/SalesTraining.vue";
import TrainingEssentials from "../pages/TrainingEssentials.vue";


import CET from "../pages/CET.vue";
import ProductSchool from "../pages/ProductSchool.vue";
import ProductSchoolInfo from "@/pages/ProductSchoolInfo.vue";
import ProductSchoolRegistrants from "@/pages/ProductSchoolRegistrants.vue";
import ProductSchoolReport from "@/pages/ProductSchoolReport.vue";
import FortNewSingle from "@/pages/FortNewSingle.vue";
import ProductChat from "@/pages/ProductChat.vue";
import ProductChatIntel from "@/pages/ProductChatIntel.vue";
import FortLearningAdmin from "@/pages/FortLearningAdmin.vue";
import FortLearningEnroll from "@/pages/FortLearningEnroll.vue";
import FortLearningPoints from "@/pages/FortLearningPointsNew.vue";
import FortLearningUserPoints from "@/pages/FortLearningUserPoints.vue";
import FortLearning from "@/pages/FortLearning.vue";
import FortCourse from "@/pages/FortCourse.vue";
import GAPListings from "@/pages/GAPListings.vue";
import GAPDetails from "@/pages/GAPDetails.vue";
import CETUpdate from "@/pages/CETUpdate.vue";
import CETUpdates from "@/pages/CETUpdates.vue";
import CETUpdatesSingle from "@/pages/CETUpdatesSingle.vue";
import ProductChatReport from "@/pages/ProductChatReport.vue";
// import BasicInstallationCourse from "../pages/BasicInstallationCourse.vue";
import Admin from "../pages/Admin.vue";




import store from "../store";


// const  = () => import("../pages/login");



const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // Back/forward buttons: return to where you were
    if (savedPosition) return savedPosition;

    // Links to an anchor (#section)
    if (to.hash) return { el: to.hash, behavior: "smooth" };

    // Same page, only the query changed (filters, paging): stay put
    if (to.path === from.path) return false;

    // Routes that use the mobile scroll target
    if (to.matched.some(m => m.meta.scrollToTop)) {
      const target = document.getElementById("mobileScrollTarget");
      if (target) return { el: target, top: 0 };
    }

    // Everything else: top of the page
    return { top: 0, left: 0 };
  },
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
      meta: { layout: 'login' }
    },
     {
			path: "/forgot",
			name: "Forgot",
			component: Forgot,
      meta: { layout: 'login' }
		},
		{
			path: "/reset",
			name: "Reset",
			component: Reset,
      meta: { layout: 'login' }
		},
    {
      path: "/privacy-policy",
      name: "PrivacyPolicy",
      component: PrivacyPolicy,
      meta: { layout: 'login' }
    }, 
    {
      path: "/home",
      name: "Home",
      component: store.state.isDashboard ? HomeProjectsPodcast : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
      path: "/home2",
      name: "HomeLeaderboard",
      component: store.state.isDashboard ? HomeLeaderboard : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
      {
      path: "/home3",
      name: "HomeLeaderboardOptionB",
      component: store.state.isDashboard ? HomeLeaderboardOptionB : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
      path: "/home4",
      name: "HomeLeaderboardOptionC",
      component: store.state.isDashboard ? HomeLeaderboardOptionC : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
      path: "/home5",
      name: "HomeLeaderboardOptionMulti1",
      component: store.state.isDashboard ? HomeLeaderboardOptionMulti : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
      path: "/home6",
      name: "HomeLeaderboardOptionMulti2",
      component: store.state.isDashboard ? HomeLeaderboardOptionMulti : Home,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
      path: "/the-attic-podcast",
      name: "PodcastCollection",
      component: PodcastCollection,
      meta: {
        requiresAuth: true,
        layout: 'default',
      },
    },
    {
			path: "/questions/:id",
			name: "QuestionSingle",
			component: QuestionsSingle,
			meta: {
				requiresAuth: true,
        layout: 'default',
			},
		},
		{
			path: "/questions",
			name: "Questions",
			component: Questions,
			meta: {
				requiresAuth: true,
        layout: 'default',
			},
		},
    /*
    {
      path: "/collaborate/:id",
      name: "CollaborateSingle",
      component: CollaborateSingle,

      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/collaborate",
      name: "Collaborate",
      component: Collaborate,

      meta: {
        requiresAuth: true,
      },
    },
    */
	{
		path: "/marketing-materials",
		name: "Media",
		component: Media,
		meta: {
			requiresAuth: true,
      layout: 'default',
		},
	},
  
	{
		path: "/service-and-installation",
		name: "FieldService",
		component: FieldService,
		meta: {
			requiresAuth: true,
      layout: 'default',
		},
	},

	{
		path: "/sales-and-training",
		name: "SalesTraining",
		component: SalesTraining,
		meta: {
			requiresAuth: true,
      layout: 'default',
		},
	},

	{
		path: "/sales-and-training/training-essentials",
		name: "TrainingEssentials",
		component: TrainingEssentials,
		meta: {
			requiresAuth: true,
		},
	},

  {
    path: "/listings",
    name: "Listings",
    component: Listings,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/order-details/:id",
    name: "OrderDetails",
    component: OrderDetails,
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      requiresNotExternalPerson: true
    },
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: Invoices,
    meta: {
      requiresAuth: true,
    },
  },
  {
    path: "/acknowledgments",
    name: "Acknowledgments",
    component: Acknowledgments,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/expedited-orders",
    name: "ExpeditedOrders",
    component: ExpeditedOrders,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/expedited-order-details/:id",
    name: "ExpeditedOrderDetails",
    component: ExpeditedOrderDetails,
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/expedited-order/add/:id",
    name: "ExpeditedOrderAdd",
    component: ExpeditedOrderAdd,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true,
    },
  },

  {
    path: "/interterritorial",
    name: "Interterritorial",
    component: Interterritorial,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/interterritorial/add",
    name: "InterterritorialAdd",
    component: InterterritorialAdd,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/interterritorial/:id",
    name: "InterterritorialDetails",
    component: InterterritorialDetails,
    meta: {
      requiresAuth: true,
      scrollToTop: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/cash-management",
    name: "CashManagement",
    component: CashManagement,
    meta: {
      requiresAuth: true,
      requiresCashManagement: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/cash-management/:id",
    name: "CashManagementSingle",
    component: CashManagementSingle,
    meta: {
      requiresAuth: true,
      requiresCashManagement: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/lead-times",
    name: "LeadTimes",
    component: LeadTimes,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },

  {
    path: "/lead-times/edit",
    name: "LeadTimesEdit",
    component: LeadTimesEdit,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/lead-time-history",
    name: "LeadTimeHistory",
    component: LeadTimeHistory,
    meta: {
      requiresAuth: true,
      requiresSpacesaverEmployee: true,
    },
  },
  {
    path: "/cet-extension-training",
    name: "CET",
    component: CET,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/price-lists",
    name: "Parts",
    component: Parts,
    meta: {
      requiresAuth: true,
    },
  },

  {
    path: "/warranty",
    name: "Warranty",
    component: Warranty,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },
  {
    path: "/gsas",
    name: "GSAs",
    component: GSAs,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },
  {
    path: "/ads",
    name: "ADS",
    component: ADS,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },
  {
    path: "/rfrs",
    name: "RFRs",
    component: RFRs,
    meta: {
      requiresAuth: true,
      requiresNotExternalPerson: true
    },
  },
  {
      path: "/rfr-details/:id",
      name: "RFRDetails",
      component: RFRDetails,
      meta: {
        requiresAuth: true,
        scrollToTop: true,
        requiresNotExternalPerson: true
      },
    },
    {
			path: "/rfr/add/:id",
			name: "RFRadd",
			component: RFRadd,
			meta: {
				requiresAuth: true,
				requiresNotExternalPerson: true
			},
		},
    {
			path: "/rgas",
			name: "RGAs",
			component: RGAs,
			meta: {
				requiresAuth: true,
				requiresNotExternalPerson: true
			},
		},   
		{
			path: "/rga-details/:id",
			name: "RGADetails",
			component: RGADetails,
			meta: {
				requiresAuth: true,
				scrollToTop: true,
				requiresNotExternalPerson: true
			},
		},  
		{
			path: "/rga/add/:id",
			name: "RGAadd",
			component: RGAadd,
			meta: {
				requiresAuth: true,
				requiresNotExternalPerson: true
			},
		},
    {
      path: "/announcements",
      name: "Announcements",
      component: Announcements,

      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/announcement/:slug",
      name: "AnnouncementSingle",
      component: AnnouncementSingle,

      meta: {
        requiresAuth: true,
      },
    },
    {
			path: "/major-project-registration",
			name: "MajorProjects",
			component: MajorProjects,
			meta: {
				requiresAuth: true,
			},
		},
    {
      path: "/from-the-fort",
      name: "FromFortNew",
      component: FromFortNew,

      meta: {
        requiresAuth: true,
      },
    },
 
    {
      path: "/trailblazer",
      name: "trailblazor",
      component: Trailblazor,

      meta: {
        requiresAuth: true,
      },
    },
       
    {
      path: "/trailblazer/:slug",
      name: "trailblazorPost",
      component: TrailblazorSingle,
      meta: {
        requiresAuth: true,
      },
    },
  
    {
      path: "/ac-list",
      name: "ACList",
      component: ACList,

      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/calendar",
      name: "Calendar",
      component: Calendar,

      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/faq",
      name: "FAQ",
      component: FAQ,

      meta: {
        requiresAuth: true,
      },
    },
    {
			path: "/eto-and-inspiring-installs",
			name: "ETOProjects",
			component: ETOProjects,
			meta: {
				requiresAuth: true,
			},
		},
		{
			path: "/eto-and-inspiring-installs/:id",
			name: "ETOProjectDetails",
			component: ETOProjectDetails,
			meta: {
				requiresAuth: true,
			},
		},
    {
			path: "/reports",
			name: "ReportsNew",
			component: ReportsNew,
			meta: {
				requiresAuth: true,
				requiresReports: true,
				requiresNotExternalPerson: true
			},
		},
    {
			path: "/reports/sales-reps",
			name: "SalesReps",
			component: SalesReps,
			meta: {
				requiresAuth: true,
				requiresReports: true,
				requiresNotSales: true,
				requiresNotExternalPerson: true
			},
		},
    {
			path: "/reportdetails/",
			name: "ReportDetails",
			component: ReportDetails,
			meta: {
				requiresAuth: true,
				requiresReports: true,
				scrollToTop: true,
				requiresNotExternalPerson: true
			},
		},
    {
			path: "/release-notes",
			name: "ReleaseNotes",
			component: ReleaseNotes,
			meta: {
				requiresAuth: true,
			},
    },
    
    {
			path: "/product-school",
			name: "ProductSchool",
			component: ProductSchool,
			meta: {
				requiresAuth: true,
			},
    },
    {
			path: "/product-school-info",
			name: "ProductSchoolInfo",
			component: ProductSchoolInfo,
			meta: {
				requiresAuth: true,
			},
    },
    {
			path: "/product-school-registrants",
			name: "ProductSchoolRegistrants",
			component: ProductSchoolRegistrants,
			meta: {
				requiresAuth: true,
        requiresSpacesaverEmployee: true,
			},
    },
    {
			path: "/product-school-report",
			name: "ProductSchoolReport",
			component: ProductSchoolReport,
			meta: {
				requiresAuth: true,
        requiresSpacesaverEmployee: true,
			},
    },

    {
			path: "/from-the-fort/:slug",
			name: "FortNewSingle",
			component: FortNewSingle,
			meta: {
				requiresAuth: true,
			},
    },

    {
			path: "/sales-and-marketing-agent",
			name: "ProductChat",
			component: ProductChat,
			meta: {
				requiresAuth: true,
        // requiresSpacesaverEmployee: true,
			},
    },
     {
			path: "/sales-and-marketing-agent-intel",
			name: "ProductChatIntel",
			component: ProductChatIntel,
			meta: {
				requiresAuth: true,
        // requiresSpacesaverEmployee: true,
			},
    },
    {
        path: "/fortified-learning/admin/completions",
        name: "FortLearningAdmin",
        component: FortLearningAdmin,
        meta: {
          requiresAuth: true,
          requiresTrainingAdmin: true,
        },
     },

     
     {
        path: "/fortified-learning/admin/credits",
        name: "FortLearningPoints",
        component: FortLearningPoints,
        meta: {
          requiresAuth: true,
          requiresTrainingAdmin: true,
          layout: 'default',
        },
     },
     {
        path: "/fortified-learning/admin/enroll",
        name: "FortLearningEnroll",
        component: FortLearningEnroll,
        meta: {
          requiresAuth: true,
          requiresTrainingAdmin: true,
          layout: 'default',
        },
     },
    
     {
			path: "/fortified-learning",
			name: "FortLearning",
			component: FortLearning,
			meta: {
				requiresAuth: true,
        layout: 'default',
			},
    },

    {
			path: "/fortified-learning/course/:courseid",
			name: "FortCourse",
			component: FortCourse,
			meta: {
				requiresAuth: true,
        layout: 'default',
			},
    },
    {
      path: "/fortified-learning/admin/user/:userid",
      name: "FortLearningUserPoints",
      component: FortLearningUserPoints,
      meta: { requiresTrainingAdmin: true },
    },
    {
			path: "/freespan-opportunity-registration",
			name: "OpportunityRegistration",
			component: OpportunityRegistration,
			meta: {
				requiresAuth: true,
			},
    },
    {
			path: "/gap-orders",
			name: "GAPListings",
			component: GAPListings,
			meta: {
				requiresAuth: true,
        requiresSpacesaverEmployee: true,
			},
    },
    
    {
			path: "/gap-order-details/:id",
			name: "GAPDetails",
			component: GAPDetails,
			meta: {
				requiresAuth: true,
        requiresSpacesaverEmployee: true,
			},
    },
    
    {
			path: "/cet-weekly-status-update",
			name: "CETUpdate",
			component: CETUpdate,
			meta: {
				requiresAuth: true,
			},
    },
    {
      path: "/cet-updates",
      name: "CETUpdates",
      component: CETUpdates ,

      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/cet-updates/:slug",
      name: "CETUpdatesSingle",
      component: CETUpdatesSingle,

      meta: {
        requiresAuth: true,
      },
    },
    /*
    {
			path: "/basic-installation-course",
			name: "BasicInstallation",
      component: BasicInstallationCourse,
			meta: {
				requiresAuth: true,
        layout: "external"
			},
		},
    */
    {
			path: "/admin/sam-report",
			name: "SAMReport",
			component: ProductChatReport,
			meta: {
				requiresAuth: true,
				requiresAdmin: true,
			},
		},
    {
			path: "/admin",
			name: "Admin",
			component: Admin,
			meta: {
				requiresAuth: true,
				requiresAdmin: true,
			},
		},
    {
      path: "/:catchAll(.*)",
      name: "NotFound",
      component: () => import("../pages/404.vue"),
      meta: {
        requiresAuth: true,        
        layout: 'default',
      }
    },
  ],
});



router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('SSCUSER');

	if (to.matched.some((record) => record.meta.requiresAuth)) {
		if (store.getters.isLoggedIn) {
			// Sentry.setUser({ email: store.state.user.Email });
			next();
			return;
		}

		//next("/");
		//const loginpath = window.location.pathname;
		// const loginpath = window.location.url;
    const loginpath = to.fullPath;
		//next({ name: "Login", query: { from: loginpath } });
		next({ name: "Login", query: { from: to.fullPath } });
		next();
		//this.$router.push({ name: "Login", query: { redirect: "/path" } });
	} else {
		next();
	}
});

/*
router.beforeEach((to, from, next) => {
  console.log('Guard triggered for route:', to.fullPath); // Debug: Confirm guard runs

  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const token = localStorage.getItem('SSCUSER');
    console.log('Token retrieved:', token ? 'Present' : 'Missing'); // Debug

    if (!token) {
      console.log('No token, redirecting to login');
      next({ name: "Login", query: { from: to.fullPath } });
      return;
    }

    // Decode early to check validity/expiration BEFORE store check
    let decoded = null;
    try {
      decoded = jwtDecode(token);
      console.log('Decoded payload:', decoded); // Debug: See full payload, including exp

      if (!decoded.exp) {
        console.warn('No exp claim in token – treating as invalid/expired');
        throw new Error('Missing exp claim');
      }

      const currentTime = Date.now() / 1000;
      console.log('Current time (sec):', currentTime, 'Token exp:', decoded.exp); // Debug

      if (decoded.exp < currentTime) {
        console.log('Token expired, logging out');
        localStorage.removeItem('SSCUSER');
        store.dispatch('auth/logout'); // Invalidate store
        next({ name: "Login", query: { from: to.fullPath } });
        return;
      }

      console.log('Token valid');
    } catch (error) {
      console.error('Decode failed (invalid/expired/malformed token):', error); // Debug
      localStorage.removeItem('SSCUSER');
      store.dispatch('auth/logout'); // Invalidate store
      next({ name: "Login", query: { from: to.fullPath } });
      return;
    }

    // Now check store (after confirming token is valid)
    if (!store.getters.isLoggedIn) {
      console.log('Store says not logged in, redirecting');
      next({ name: "Login", query: { from: to.fullPath } });
      return;
    }

    // All good: Proceed
    // Sentry.setUser({ email: store.state.user.Email });
    console.log('Guard passed');
    next();
  } else {
    console.log('Public route, proceeding'); // Debug
    next();
  }
});
*/
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {

    if (store.getters.isLoggedIn) {
      //console.log("is logged in in store");
      next();
      return;

    } else {

      console.log("isn't logged in in store");
      next({
        path: "/",
        query: { redirect: to.fullPath },
      });

    }
    //next("/");
  } else {

    next();
    
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    if (store.getters.isAdmin) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresTrainingAdmin)) {
    if (store.getters.isTrainingAdmin) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresInternalTrainingAdmin)) {
    if (store.getters.isInternalTrainingAdmin) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


/*
router.beforeEach((to) => {
  if (to.meta.requiresInternalTrainingAdmin && !store.getters.isInternalTrainingAdmin) {
    return "/fortified-learning";
  }
  if (to.meta.requiresTrainingAdmin && !store.getters.isTrainingAdmin) {
    return "/fortified-learning";
  }
});
*/

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresSpacesaverEmployee)) {
    if (store.getters.isSpacesaverEmployee) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresCashManagement)) {
    if (store.getters.isCashManagement) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresReports)) {
    if (store.getters.isReports) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresNotSales)) {
    if (!store.getters.isSales) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresNotExternalPerson)) {
    if (!store.getters.isExternalPerson) {
      next();
      return;
    }

    next("/");
  } else {
    next();
  }
});

/*
navigation duplicated exception fix. This exception gets thrown when an individual is on a page. 
and tries to navigate to the same page
*/

const originalPush = router.push;
router.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name !== "NavigationDuplicated") throw err;
  });
};


function getAuthToken() {
  return localStorage.getItem('SSCUSER');
}

async function reportPageVisit(to) {
  const token = getAuthToken()
  if (!token) {
    // Optional: log anonymous visits or just return
    return
  }

  const payload = {
    page: to.fullPath,           // includes query string (recommended)
    path: to.path,
    routeName: to.name,
    timestamp: new Date().toISOString(),   // ISO 8601 – best for backend
    // Add anything else useful: to.query, to.meta, etc.
  }

  console.log(payload)

  /*
  try {
    // Fire-and-forget is fine here
    fetch('/api/analytics/page-visit', {   // ← change to your actual endpoint
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(payload)
    }).catch(err => {
      // Fail silently so analytics never break the app
      console.warn('Page visit logging failed:', err)
    })
  } catch (e) {
    console.warn('Error preparing page visit log:', e)
  }
  */
}

router.afterEach((to, from) => {
  reportPageVisit(to)
})

/*
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => {
		//console.log(err.name);
		if (err.name !== 'NavigationDuplicated') throw err
	});
}
*/

export default router;
